import { useQuery } from "react-query";
import { getFireAlarmSystemsByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";
import { toast } from "components/toastNotification";

export const useFireAlarmSystemsByRecordNumber = (recNumber) => {
    const { data, isLoading, error } = useQuery(
        ["GetFireAlarmSystemsByRecordNumber", recNumber],
        () => getFireAlarmSystemsByRecordNumber(recNumber),
        {
            refetchOnWindowFocus: false,
            onError: () => {
                toast.fire(
                    "Unexpected issue",
                    "Unable to load Fire Alarm System record right now. Please try again shortly.",
                    "error"
                );
            }
        },
    );

    return {
        data: error ? [] : data ?? [],
        isLoading
    }
};
